import { styled, Box, ButtonBase } from '@mui/material';

export const FooterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: '16px 24px',
  background: '#DBEDE3',
  width: '100%',
  gap: '16px',
  [theme.breakpoints.down('md')]: {
    flexWrap: 'wrap',
    gap: '12px',
    padding: '16px',
  },
}));

export const SelectionText = styled(Box)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 400,
  color: theme.palette.secondary.contrastText,
  whiteSpace: 'nowrap',
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  padding: '0 24px',
  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
    flexWrap: 'wrap',
    gap: '12px',
    padding: 0,
  },
}));

export const ActionButton = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '0',
  backgroundColor: 'transparent',
  border: 'none',
  fontSize: '14px',
  fontWeight: 400,
  fontFamily: 'inherit',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
  whiteSpace: 'nowrap',
  '&:hover': {
    opacity: 0.8,
  },
  '& .icon-circle': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    transition: 'all 0.2s ease-in-out',
    flexGrow: 1,
  },
  '& svg': {
    width: '32px',
    height: '32px',
    flexShrink: 0,
    color: '#fff',
    fill: '#fff',
    '& path': {
      fill: '#fff',
      stroke: '#fff',
    },
  },
  '& span': {
    lineHeight: '20px',
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'inherit',
    color: theme.palette.primary.main,
  },
}));

export const ClearButton = styled(ButtonBase)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '14px',
  fontWeight: 400,
  fontFamily: 'inherit',
  cursor: 'pointer',
  transition: 'opacity 0.2s ease-in-out',
  whiteSpace: 'nowrap',
  padding: 0,
  '&:hover': {
    opacity: 0.8,
    backgroundColor: 'transparent',
  },
}));
